// extracted by mini-css-extract-plugin
export default {"name":"email_name__KbK3D","email":"email_email__VgLuI","tel":"email_tel__OFP8T","btn":"email_btn__oZs6x","subTitel":"email_subTitel__ozcg5"};